const translation = {
  pageTitle: '시작하기 🎉',
  welcome: 'Dify에 오신 것을 환영합니다. 계속하려면 로그인하세요.',
  email: '이메일 주소',
  emailPlaceholder: '이메일 주소를 입력하세요',
  password: '비밀번호',
  passwordPlaceholder: '비밀번호를 입력하세요',
  name: '사용자 이름',
  namePlaceholder: '사용자 이름을 입력하세요',
  forget: '비밀번호를 잊으셨나요?',
  signBtn: '로그인',
  installBtn: '설치',
  setAdminAccount: '관리자 계정 설정',
  setAdminAccountDesc: '앱 생성 및 LLM 제공자 관리 등 최고 권한을 가진 관리자 계정 설정',
  createAndSignIn: '계정 생성 및 로그인',
  oneMoreStep: '마지막 단계',
  createSample: '이 정보를 기반으로 샘플 앱을 생성합니다.',
  invitationCode: '초대 코드',
  invitationCodePlaceholder: '초대 코드를 입력하세요',
  interfaceLanguage: '인터페이스 언어',
  timezone: '시간대',
  go: 'Dify로 이동',
  sendUsMail: '간단한 소개를 메일로 보내주시면 초대 요청을 처리해드립니다.',
  acceptPP: '개인정보 처리 방침에 동의합니다.',
  reset: '비밀번호를 재설정하려면 다음 명령을 실행하세요:',
  withGitHub: 'GitHub로 계속',
  withGoogle: 'Google로 계속',
  rightTitle: 'LLM의 최대 잠재력을 발휘하세요',
  rightDesc: '매력적이고 조작 가능하며 개선 가능한 AI 애플리케이션을 쉽게 구축하세요.',
  tos: '이용약관',
  pp: '개인정보 처리 방침',
  tosDesc: '가입함으로써 다음 내용에 동의하게 됩니다.',
  goToInit: '계정이 초기화되지 않았다면 초기화 페이지로 이동하세요.',
  donthave: '계정이 없으신가요?',
  invalidInvitationCode: '유효하지 않은 초대 코드입니다.',
  accountAlreadyInited: '계정은 이미 초기화되었습니다.',
  error: {
    emailEmpty: '이메일 주소를 입력하세요.',
    emailInValid: '유효한 이메일 주소를 입력하세요.',
    nameEmpty: '사용자 이름을 입력하세요.',
    passwordEmpty: '비밀번호를 입력하세요.',
    passwordInvalid: '비밀번호는 문자와 숫자를 포함하고 8자 이상이어야 합니다.',
  },
  license: {
    tip: 'Dify Community Edition을 시작하기 전에 GitHub의',
    link: '오픈 소스 라이선스',
  },
  join: '가입하기',
  joinTipStart: '당신을 초대합니다.',
  joinTipEnd: '팀에 가입하세요.',
  invalid: '링크의 유효 기간이 만료되었습니다.',
  explore: 'Dify를 탐색하세요',
  activatedTipStart: '이제',
  activatedTipEnd: '팀에 가입되었습니다.',
  activated: '지금 로그인하세요',
  adminInitPassword: '관리자 초기화 비밀번호',
  validate: '확인',
}

export default translation
